module.exports = __webpack_public_path__ + "img/401.0237cb01.png";